import { render, staticRenderFns } from "./GruposPraJa.vue?vue&type=template&id=0b7263ed&scoped=true&"
import script from "./GruposPraJa.vue?vue&type=script&lang=js&"
export * from "./GruposPraJa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7263ed",
  null
  
)

export default component.exports